import React, { CSSProperties, ReactNode } from 'react';
import { styled, ITheme, IStyleFunctionOrObject, Stack, StackItem, Label } from '@fluentui/react';

type Props = {
    theme?: ITheme;
    styles?: IStyleFunctionOrObject<any, any>;
    text: string;
    headerStyle?: CSSProperties;
    labelStyle?: CSSProperties;
    headingCenterContent?: ReactNode;
    headingEndContent?: ReactNode;
    isRequired?: boolean;
};

const SubSectionHeader = (props: Props) => {
    const headerStyles: CSSProperties = {
        padding: '5px 5px 5px 10px',
        background: props.theme?.palette.white,
        display: 'flex',
        alignItems: 'center',
        zIndex: 20,
        ...props.headerStyle,
    };

    return (
        <Stack style={{ ...headerStyles }} className="ms-depth-4" horizontal tokens={{ childrenGap: 20 }}>
            <StackItem>
                <Label style={{ ...props.labelStyle!, padding: 0 }} required={props.isRequired}>
                    {props.text}
                </Label>
            </StackItem>
            <StackItem grow={1}>
                <Stack>{props.headingCenterContent}</Stack>
            </StackItem>
            <StackItem>
                <Stack horizontal style={{ justifyContent: 'flex-end', display: 'flex' }} tokens={{ childrenGap: 10 }}>
                    {props.headingEndContent}
                </Stack>
            </StackItem>
        </Stack>
    );
};

export default styled<Props, any, any>(SubSectionHeader, {});
